import {
	CATEGORY_LOADING_STATUS,
	CATEGORY_FETCH_ERRORS,
	CATEGORY_FETCH,
	CATEGORY_SET,
	CATEGORY_DEFAULT_STRUCTURE,
} from './types'

const initialState = {
	loading: false,
	categories: [],
	errors: [],
	selectedCategory: false
}

export const state = { ...initialState }

export default {
	[CATEGORY_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[CATEGORY_FETCH]: (state, payload) => {
		state.categories = payload
	},

	[CATEGORY_FETCH_ERRORS]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CATEGORY_SET]: (state, payload) => {
		state.selectedCategory = payload
	},

	[CATEGORY_DEFAULT_STRUCTURE]: (state) => {
		state.categorys = state.categorys.map(el => ({
			...el,
			selectedCategory: true
		}))
	},
}
